import { BaseQueryFn } from '@reduxjs/toolkit/dist/query';
import { EndpointBuilder } from '@reduxjs/toolkit/dist/query/endpointDefinitions';
import { TAG_USER } from 'services/TagsConstants';

export default (build: EndpointBuilder<BaseQueryFn, string, string>) =>
  build.mutation<NewPhone, NewPhone>({
    query: (credentials) => ({
      url: '/partner-user/current/change-phone-number-request',
      method: 'POST',
      body: credentials,
    }),
    invalidatesTags: [TAG_USER],
  });

export type NewPhone = {
  phoneNumber: string;
  phoneNumberCountryCode: string;
};
